import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import "dayjs/locale/cs";

dayjs.locale("cs");

const normalizeEventType = (value) => {
  const lower = value?.toLowerCase() || "";
  switch (lower) {
    case "oběd":
      return "oběd";
    case "porada":
      return "porada";
    case "školení":
      return "školení";
    case "meeting":
    default:
      return "meeting";
  }
};

const Modal = ({ eventData, onClose, onSave, onDelete }) => {
  const [eventType, setEventType] = useState("meeting");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [description, setDescription] = useState("");
  const [organizer, setOrganizer] = useState("");

  useEffect(() => {
    if (eventData) {
      setEventType(normalizeEventType(eventData.eventType));
      setStartTime(dayjs(eventData.start).format("YYYY-MM-DDTHH:mm"));
      setEndTime(dayjs(eventData.end).format("YYYY-MM-DDTHH:mm"));
      setDescription(eventData.description || "");
      setOrganizer(eventData.organizer || "");
    }
  }, [eventData]);

  const handleSave = () => {
    onSave({
      ...eventData,
      eventType,
      start: new Date(startTime),
      end: new Date(endTime),
      description,
      organizer,
    });
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-lg font-semibold mb-4">
          {eventData?.id ? "Upravit událost" : "Přidat událost"}
        </h2>

        <label className="block mb-3">
          Typ události:
          <select
            value={eventType}
            onChange={(e) => setEventType(e.target.value)}
            className="w-full border p-2 rounded"
          >
            <option value="meeting">Meeting</option>
            <option value="porada">Porada</option>
            <option value="školení">Školení</option>
            <option value="oběd">Oběd</option>
          </select>
        </label>

        <label className="block mb-3">
          Začátek:
          <input
            type="datetime-local"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
            className="w-full border p-2 rounded"
          />
        </label>

        <label className="block mb-3">
          Konec:
          <input
            type="datetime-local"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
            className="w-full border p-2 rounded"
          />
        </label>

        <label className="block mb-3">
          Pořadatel:
          <input
            type="text"
            value={organizer}
            onChange={(e) => setOrganizer(e.target.value)}
            className="w-full border p-2 rounded"
            disabled={!!eventData?.organizer}
          />
        </label>

        <label className="block mb-3">
          Popis:
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full border p-2 rounded"
          />
        </label>

        <div className="flex justify-end gap-3 mt-4">
          {eventData?.id && (
            <button
              onClick={() => onDelete(eventData.id)}
              className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700"
            >
              Smazat
            </button>
          )}
          <button
            onClick={onClose}
            className="px-4 py-2 rounded bg-gray-400 text-white hover:bg-gray-500"
          >
            Zrušit
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
          >
            Uložit
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;